import { API_SAVE_API_CONFIG, API_GET_API_CONFIG_LIST } from '@/common/constants';
import { get, post, del, put } from '@/utils/http';

export const saveApiConfig = (param) => {
    return post(API_SAVE_API_CONFIG, param);
};
export const getApiConfigList = (param) => {
    return post(API_GET_API_CONFIG_LIST, param);
};



// WEBPACK FOOTER //
// ./src/data-model/system/api-model.js